import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "onOk", "closable", "title", "footer", "children", "visible", "afterClose", "transitionName"];
import { IconClose16pxRegular } from "@pionex-web-kit/icons";
import cns from "classnames";
import React, { forwardRef, useContext, useMemo } from "react";
import { ConfigContext } from "../ConfigProvider";
import Drawer from "../Drawer";
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/forwardRef(function MobileDrawer(_ref, ref) {
  var className = _ref.className,
    onOk = _ref.onOk,
    closable = _ref.closable,
    title = _ref.title,
    footer = _ref.footer,
    children = _ref.children,
    visible = _ref.visible,
    afterClose = _ref.afterClose,
    transitionName = _ref.transitionName,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(ConfigContext),
    getPopupContainer = _useContext.getPopupContainer,
    getPrefixCls = _useContext.getPrefixCls,
    direction = _useContext.direction;
  var prefixCls = getPrefixCls("mobile-drawer");
  var footerNode = useMemo(function () {
    if (closable) {
      return /*#__PURE__*/_jsx("div", {
        className: "".concat(prefixCls, "-close-icon"),
        onClick: props.onCancel,
        children: /*#__PURE__*/_jsx(IconClose16pxRegular, {
          size: 16
        })
      });
    }
    if (footer) {
      return footer;
    }
  }, [closable, footer, props.onCancel]);
  return /*#__PURE__*/_jsx(Drawer, {
    className: cns("".concat(prefixCls), className),
    closable: false,
    footer: footerNode,
    title: title,
    placement: "bottom",
    height: "auto",
    onClose: props.onCancel,
    afterVisibleChange: function afterVisibleChange(bool) {
      if (!bool) {
        afterClose === null || afterClose === void 0 ? void 0 : afterClose();
      }
    },
    children: children,
    visible: visible,
    ref: ref
  });
});